import React, { useContext, useEffect } from "react"
import { graphql } from "gatsby"
import loadable from "@loadable/component"

import Layout from "components/layout"
import { LoaderContext, ScreenContext } from "components/Providers"

import { CompaniesData } from "types/companies"

import Hero from "sections/home/01-Hero"
import Years from "sections/home/02-Years"
import Doge from "sections/home/03-Doge"
import WholeTime from "sections/home/04-WholeTime"
import Conviction from "sections/home/05-Conviction"
import Quotes from "sections/home/06-Quotes"
import Videos from "sections/home/07-Videos"
import Relationships from "sections/home/08-Relationships"
import Companies from "sections/home/09-Companies"
import NewsFeed from "sections/home/10-NewsFeed"
import ContainedBanner from "components/uIElements/ContainedBanner"

const SideNav = loadable(() => import("components/SideNav"))

const menu = [
  { title: "Our Story", slug: "#home-Hero" },
  { title: "In It With You", slug: "#Quotes" },
  { title: "Our Founders", slug: "#Relationships" },
  { title: "Highlights", slug: "#Companies" },
  { title: "News Feed", slug: "#NewsFeed" },
]

type Props = {
  data: CompaniesData
}

const IndexPage: React.FC<Props> = ({ data }) => {
  const { mobile } = useContext(ScreenContext)
  const { setLoad } = useContext(LoaderContext)

  useEffect(() => {
    setLoad("")
  }, [])

  return (
    <Layout title="RRE" menu={menu}>
      {!mobile && <SideNav menu={menu} />}
      <Hero />
      <Years />
      <Doge />
      <WholeTime />
      <Conviction />
      <Quotes />
      <Videos />
      <Relationships />
      {/* until performance is improved, i'm only feeding in 18 companies */}
      <Companies companies={data.allContentfulCompany.nodes.slice(0, 18)} />
      <NewsFeed />
      <ContainedBanner />
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query HomePageQuery {
    allContentfulCompany {
      nodes {
        color
        description {
          description
        }
        founded
        headquarters
        industries {
          title
        }
        invested
        investmentStage
        investment_team_member {
          name
        }
        logo {
          file {
            url
            details {
              image {
                height
                width
              }
            }
          }
          description
        }
        participation
        title
        url
        exit
      }
    }
  }
`
